module.exports = __webpack_public_path__ + "img/user.81362517.svg";